





















































































































import Vue from "vue"
import { CsvImportResponse } from "@/model/dto/csv-upload.ts"
import Datatable, { DatatableOptions, IDatatable } from "@/components/datatable/Datatable.vue"
import { FieldDescription } from "@/model/entity/field-descriptor"
import { DatatableEntity } from "@/model/entity/datatable-entity"

interface UploadData {
  fileResponseList: CsvImportResponse<DatatableEntity>[]
  activeFile: string[]
  options: DatatableOptions
}

export interface IUpload extends UploadData, Vue {}

export default Vue.extend({
  components: { Datatable },
  data(): UploadData {
    return {
      fileResponseList: [],
      activeFile: [],
      options: {}
    }
  },
  props: {
    fields: {
      default: [] as FieldDescription[]
    },
    title: {
      type: String,
      default: ""
    },
    hasTable: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    submit() {
      this.$emit(
        "submit",
        this.fileResponseList
          .filter(
            fileResponse =>
              exists(fileResponse.items) &&
              fileResponse.items.length > 0 &&
              fileResponse.items.some((item: any) => item.csvStatus === "VALIDATED")
          )
          .map(fileResponse => {
            fileResponse.items = fileResponse.items.filter((item: any) => item.csvStatus === "VALIDATED")
            return fileResponse
          })
      )
    },
    getData(items: DatatableEntity[], index: number) {
      return (page: number, size: number, datatable: any) => {
        this.$nextTick(() => {
          datatable.items = items.slice((page - 1) * size, page * size)
          datatable.total = items.length
        })
      }
    },
    uploadFile(fileUploadRequest: any) {
      const fileData = new FormData()
      fileData.append("file", fileUploadRequest.file, fileUploadRequest.file.name)
      this.$emit("upload", fileData)
    },
    getMessage(csvStatus: string) {
      if (csvStatus === "VALIDATED") {
        return this.$t("upload.status.validation")
          .toString()
          .toUpperCase()
      } else if (csvStatus === "PROCESSED") {
        return this.$t("upload.status.processed")
          .toString()
          .toUpperCase()
      } else if (csvStatus === "ERROR") {
        return this.$t("upload.status.error")
          .toString()
          .toUpperCase()
      }
      return csvStatus.toLowerCase()
    },
    getType(csvStatus: string) {
      if (csvStatus === "VALIDATED") {
        return "success"
      } else if (csvStatus === "PROCESSED") {
        return "info"
      } else if (csvStatus === "ERROR") {
        return "danger"
      }
      return csvStatus.toLowerCase()
    },
    resolveRowClass(event: any) {
      if (event.row.csvStatus === "PROCESSED") {
        return "processed-line"
      }
      return ""
    }
  },
  computed: {
    submitDisabled(): boolean {
      return (
        this.fileResponseList.length === 0 ||
        this.fileResponseList.every(
          res =>
            !exists(res.items) ||
            res.items.length === 0 ||
            res.items.every(
              (item: any) =>
                item.csvStatus === "WARNING" || item.csvStatus === "ERROR" || item.csvStatus === "PROCESSED"
            )
        )
      )
    }
  }
})
